import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { persistReducer, persistStore } from 'redux-persist';
import { apiCaller, apiLocationCaller } from './query';
import bannerSlice from './slice/banner.slice';
import toastSlice from './slice/toast.slice';
import authSlice from './slice/auth.slice';
import saveBarSlice from './slice/savebar.slice';
import settingSlice from './slice/setting.slice';
import errorSlice from './slice/error.slice';
import ggApiBannerSlice from './slice/ggApiBanner.slice';
import sessionStorage from 'redux-persist/es/storage/session';
import localStorage from 'redux-persist/es/storage';
import locationSlice from './slice/location.slice';
import pickupSlice from './slice/pickup.slice';
import deliverySlice from './slice/delivery.slice';
import widgetSlice from './slice/widget.slice';
import previewOptionSlice from './slice/preview.slice';
import tabSlice from './slice/tab.slice';
import shippingSlice from './slice/shipping.slice';
import previewDateTimeSlice from './slice/previewDateTime.slice';
import onboardingSlice from './slice/onboarding.slice';
import orderSlice from './slice/order.slice';
import widgetTextSlice from './slice/widgetText.slice';
import shopInfoSlice from './slice/shop.slice';
import emailSlice from './slice/email.slice';

const tabConfig = {
  key: 'tab',
  storage: sessionStorage,
};

const bannerPersistConfig = {
  key: 'banner',
  storage: sessionStorage,
};

const ggApiBannerPersistConfig = {
  key: 'gg-api-banner',
  storage: sessionStorage,
};

const authPersistConfig = {
  key: 'auth',
  storage: localStorage,
};

const onboardingPersistConfig = {
  key: 'onboarding',
  storage: sessionStorage,
};

const rootReducer = combineReducers({
  toast: toastSlice.reducer,
  auth: persistReducer(authPersistConfig, authSlice.reducer),
  banner: persistReducer(bannerPersistConfig, bannerSlice.reducer),
  ggApiBanner: persistReducer(ggApiBannerPersistConfig, ggApiBannerSlice.reducer),
  tab: persistReducer(tabConfig, tabSlice.reducer),
  saveBar: saveBarSlice.reducer,
  error: errorSlice.reducer,
  setting: settingSlice.reducer,
  location: locationSlice.reducer,
  pickup: pickupSlice.reducer,
  delivery: deliverySlice.reducer,
  shipping: shippingSlice.reducer,
  widget: widgetSlice.reducer,
  previewOption: previewOptionSlice.reducer,
  previewDateTime: previewDateTimeSlice.reducer,
  apiCaller: apiCaller.reducer,
  apiLocationCaller: apiLocationCaller.reducer,
  onboarding: persistReducer(onboardingPersistConfig, onboardingSlice.reducer),
  order: orderSlice.reducer,
  widgetText: widgetTextSlice.reducer,
  shopInfo: shopInfoSlice.reducer,
  email: emailSlice.reducer
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }).concat(apiCaller.middleware, apiLocationCaller.middleware);
  },
});

// setupListeners(store.dispatch)
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const persistor = persistStore(store);
export default store;
